import styled from 'styled-components'
import { Text } from './Text'

const HeadingWrapper = styled(Text)`
    padding: 50px 0px 10px 0px;
    text-align: center;
    line-height: 55px;
    font-family: 'Avenir';
    font-weight: 900;
    text-transform: uppercase;
    
    ${({ theme }) => theme.mediaQueries.xs} {
        font-size: 23px;
    }
    ${({ theme }) => theme.mediaQueries.sm} {
        font-size: 40px;
    }
`
const TextStyle = styled.div`
`

export default function HeadingComponent({ children }) {
    return (
        <>
            <TextStyle><HeadingWrapper>{children}</HeadingWrapper></TextStyle>
        </>
    )
}